import styled from "styled-components"
import titleBg1 from '../../../images/title-bg-1.png';
import titleBg2 from '../../../images/title-bg-2.png';
import Banner from '../../../images/hero-bg.png';

export const Container = styled.div`
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  @media (min-width: 1440px) {
    max-width: 1440px;
  }
`

export const BannerContainer = styled.div`
display: flex;
flex-direction: column;
justify-content: flex-end;
align-items: center;
position: relative;
width: 100%;
background-image: ${() => `url(${Banner})`};
background-size: cover;
background-position: 50% 50%;
background-repeat: no-repeat;
height: calc(100vh - 56px);
background-color: #fff;
&::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
}
`

export const BannerGif = styled.img`
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 483px;
  @media (max-width: 768px) {
    width: 230px;
  }
`

export const CountdownText = styled.div`
color: #fff;
font-size: 280px;
position: absolute;
left: 50%;
top: 50%;
transform: translate(-50%, -50%);
text-shadow: 2px 6px 56px rgba(0, 0, 0, 0.75);
font-family: KozGoPr6N-Bold;
@media (max-width: 1199.98px) {
  font-size: 200px;
}
@media (max-width: 767.98px) {
  font-size: 85px;
}
`

export const MintBtn = styled.button`
  width: 227px;
  display: inline-block;
  color: #000;
  font-size: 40px;
  border-radius: 30px;
  border: none;
  line-height: 60px;
  height: 60px;
  font-weight: 500;
  text-align: center;
  background-color: #fff;
  z-index: 1;
  padding: 0;
  font-family: KozGoPr6N-Heavy;
  &:hover {
    cursor: pointer;
  }
  @media (max-width: 767.98px) {
    width: 108px;
    line-height: 30px;
    height: 30px;
    border-radius: 15px;
    font-size: 18px;
  }
`

export const MintDecoration = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 30px;
  margin: 0 0 15px;
  z-index: 1;
  font-family: KozGoPr6N-Bold;
  &::before {
    content: '';
    width: 4px;
    height: 50px;
    background-color: #fff;
  }
  &::after {
    content: '';
    width: 15px;
    height: 15px;
    background-color: #fff;
  }
  @media (max-width: 767.98px) {
    margin: 0 0 10px;
    &::before {
      height: 150px;
    }
    &::after {
      width: 10px;
      height: 10px;
    }
  }
`

export const H2 = styled.h2`
  color: #fff;
  font-size: 60px;
  text-align: center;
  font-family: KozGoPr6N-Heavy;
  @media (max-width: 767.98px) {
    font-size: 30px;
  }
`

interface H3Props {
  isEn: boolean
}
export const H3 = styled.h3<H3Props>`
  color: rgba(200,200,200);
  font-size: ${(props) => (props.isEn ? '33px' : '50px')};
  margin: 126px 0 118px;
  font-family: KozGoPr6N-Bold;
  letter-spacing: ${(props) => (props.isEn ? '2px' : '6.1px')};
  line-height: ${(props) => (props.isEn ? '50px' : '76px')};
  @media (max-width: 767.98px) {
    font-size: ${(props) => (props.isEn ? '24px' : '29px')};
    margin: 82px 0 65px;
    text-align: center;
    line-height: ${(props) => (props.isEn ? '30px' : '45px')};
    letter-spacing: 1.7px;
    font-family: KozGoPr6N-Heavy;
  }
`

interface DescProps {
  isEn: boolean
}
export const Desc = styled.p<DescProps>`
  color: #fff;
  font-size: ${(props) => (props.isEn ? '18px' : '20px')};
  line-height: ${(props) => (props.isEn ? '30px' : '38px')};
  letter-spacing: ${(props) => (props.isEn ? '1.4px' : '2.4px')};
  padding-right: ${(props) => (props.isEn ? '0' : '0')};
  font-weight: normal;
  font-family: KozGoPr6N-Light;
  white-space: pre-wrap;
  @media (max-width: 767.98px) {
    padding-right: 0;
    font-size: 14px;
    text-align: center;
  }
`

export const RoadmapTitle = styled.h2`
  margin-bottom:  86px;
  padding-top: 128px;
  color: #fff;
  font-size: 60px;
  line-height: 57px;
  text-align: left;
  font-family: KozGoPr6N-Heavy;
  @media (max-width: 767.98px) {
    margin-bottom: 40px;
    margin-left: 0;
    font-size: 30px;
    line-height: 34px;
    text-align: center;
  }
`

interface ConentOrderListProps {
  isEn: boolean
}
export const ConentOrderList = styled.ul<ConentOrderListProps>`
  font-size: 16px;
  line-height: 38px;
  letter-spacing: 1.6px;
  letter-spacing: ${(props) => (props.isEn ? '0.64px' : '1.6px')};
  padding-top: 0;
  padding-left: 20px;
  font-family: KozGoPr6N-Light;
  color: rgba(183, 183, 183);
  list-style-type: decimal;
  max-width: 868px;
  @media (max-width: 767.98px) {
    max-width: 100%;
    font-size: 14px;
    padding-top: 16px;
  }
  li {
    white-space: pre-wrap;
  }
`

export const PhaseTitle = styled.div`
  font-family: custom-font;
  line-height: 126px;
  font-size: 127px;
  color: #c8c8c8;
  opacity: 0.15;
  margin-bottom: 35px;
  @media (max-width: 767.98px) {
    margin-bottom: 10px;
    font-size: 49px;
    line-height: 41px;
  }
`

export const Footer = styled.div`
  display: flex;
  justify-content: center;
  color: #000;
  padding: 15px 0;
  margin: 0 auto;
  font-size: 23px;
  font-family: Noto Sans TC;
  font-weight: bold;
  @media (max-width: 767.98px) {
    padding: 10px 0;
    font-size: 8px;
    flex-wrap: wrap;
  }
`
export const SocialContainer = styled.div`
  display: inline-flex;
  align-items: center;
  margin: 700px auto 160px;
  @media (max-width: 767.98px) {
    width: 177px;
    margin: 360px auto 60px;
  }
`
export const Logo = styled.img`
  width: 175px;
  @media (max-width: 767.98px) {
    width: 47px;
  }
`
export const FirmTitle = styled.div`
  width: 658px;
  height: 121px;
  background-image: ${() => `url(${titleBg1})`};
  background-size: cover;
  background-position: 100% 50%;
  margin-bottom: 24px;
  padding-bottom: 24px;
  display: flex;
  font-family: KozGoPr6N-Heavy;
  @media (max-width: 767.98px) {
    width: 212px;
    height: 41px;
    padding-bottom: 7px;
    font-size: 16px;
  }
`

export const FaqTitle = styled.div`
  width: 719px;
  height: 126px;
  background-image: ${() => `url(${titleBg2})`};
  background-size: cover;
  background-position: 0% 50%;
  margin-bottom: 45px;
  margin-left: auto;
  padding-bottom: 20px;
  display: flex;
  font-family: KozGoPr6N-Heavy;
  @media (max-width: 767.98px) {
    width: 284px;
    height: 41px;
    padding-bottom: 5px;
    font-size: 16px;
  }
`

export const FaqContainer = styled.div`
  width: 885px;
  margin-left: auto;
  @media (max-width: 767.98px) {
    width: 100%;
    padding-left: 90px;
  }
`

export const TeamTitle = styled.div`
  width: 983px;
  height: 126px;
  background-image: ${() => `url(${titleBg1})`};
  background-size: cover;
  background-position: 100% 50%;
  margin-bottom: 24px;
  padding-bottom: 20px;
  display: flex;
  font-family: KozGoPr6N-Heavy;
  @media (max-width: 767.98px) {
    width: 284px;
    height: 41px;
    padding-bottom: 5px;
    font-size: 16px;
  }
`

export const MemberAvatar = styled.img`
  max-width: 100%;
  filter: grayscale(100%);
  transition: 0.3s;
  &:hover {
    filter: none;
  }
`

interface RoadmapImgProps {
  isNotGray?: boolean
}

export const RoadmapImg = styled.img<RoadmapImgProps>`
  max-width: 100%;
  transition: 0.3s;
  filter: ${RoadmapImgProps => RoadmapImgProps.isNotGray ? 'none' : 'grayscale(100%)'};
`

export const ImgBlock = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 25px;
  img {
    width: 33.33%;
    max-width: 144px;
  }
  @media (max-width: 767.98px) {
    justify-content: center;
    gap: 15px;
    img {
      max-width: calc(33.33% - 15px);
    }
  }
`

export const AddButton = styled.div`
  background-color: rgba(159, 11, 49);
  width: 45px;
  height: 45px;
  border-radius: 50%;
  color: #000000;
  position: relative;
  &:hover {
    opacity: 0.8;
    cursor: pointer;
  }
  &::before {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    color: #fff;
    width: 20px;
    height: 4px;
    background-color: #fff;
    transform: translate(-50%, -50%) rotate(90deg);
  }
  &::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    color: #fff;
    width: 20px;
    height: 4px;
    background-color: #fff;
    transform: translate(-50%, -50%);
  }
`

export const MinusButton = styled.div`
  background-color: rgba(44, 47, 54);
  width: 45px;
  height: 45px;
  border-radius: 50%;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    opacity: 0.8;
    cursor: pointer;
  }
  &::before {
    content: '';
    color: #fff;
    width: 20px;
    height: 4px;
    background-color: #fff;
  }
`